export default function FloatingActions() {
  const items = [
    { i: "ri-phone-fill", label: "전화", href: "tel:010-2696-9689", color: "bg-primary-500" },
    {
      i: "ri-youtube-fill",
      label: "유튜브",
      href: "https://youtube.com/channel/UCenpa2i5gzClXmelYa0pizA?si=LKDV0AHLfgZpQeXg",
      color: "bg-[#FF0000]",
    },
    {
      i: "ri-instagram-line",
      label: "인스타",
      href: "https://www.instagram.com/dada.sonsa/",
      color: "bg-[#E1306C]",
    },
    {
      i: "ri-quill-pen-fill",
      label: "블로그",
      href: "https://blog.naver.com/sonsabosang",
      color: "bg-[#2DB400]",
    },
  ];
  return (
    <div className="fixed right-5 bottom-6 z-40 flex flex-col gap-3">
      {items.map((it) => (
        <a
          key={it.label}
          href={it.href}
          target={it.href.startsWith("http") ? "_blank" : undefined}
          rel="noopener noreferrer"
          className={`w-14 h-14 flex flex-col items-center justify-center rounded-full ${it.color} text-background-50 hover:scale-110 transition cursor-pointer`}
          title={it.label}
        >
          <i className={`${it.i} text-xl`}></i>
        </a>
      ))}
      <a
        href="#top"
        className="w-14 h-14 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 hover:bg-foreground-800 transition cursor-pointer"
      >
        <i className="ri-arrow-up-line text-xl"></i>
      </a>
    </div>
  );
}